// extracted by mini-css-extract-plugin
export default {"noResults":"ProfileTrainings-module__noResults"};